import { render, staticRenderFns } from "./WorkGroupManage.vue?vue&type=template&id=11805d0a&"
import script from "./WorkGroupManage.vue?vue&type=script&lang=js&"
export * from "./WorkGroupManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports